<template>
    <div
        v-if="show"
        class="max-w-fit rounded min-w-[24rem] p-2 flex gap-2 items-center m-2 "
    >
        <div class="bg-base-100 rounded min-w-[23rem] max-w-5xl border border-base-300 shadow-lg">
            <div
                class="flex justify-center w-full"
                :class="typeOfAlert"
            >
                <div class="flex-1 text-center font-bold text-lg dark:text-inverted">
                    {{ title }}
                </div>
                <button v-if="!disableClose" class="cursor-pointer text-xl font-bold mr-2 items-center dark:text-inverted" @click="closeAlert">×</button>
            </div>
            <div class="m-3 flex justify-center">{{ message }}</div>
            <slot/>
        </div>
    </div>
</template>

<script lang="ts" setup>
import {ref, computed, onMounted} from 'vue'

const props = defineProps({
    title: {
        type: String,
        required: false
    },
    message: {
        type: String,
        required: false
    },
    type: {
        type: String,
        required: false,
        default: 'info'
    },
    timeout: {
        type: String,
        required: false,
        default: '5000'
    },
    disableClose: {
        type: Boolean,
        required: false,
        default: false
    }
})

const show = ref(true)

const typeOfAlert = computed(() => ({
    'bg-red-400': props.type === 'error',
    'bg-yellow-400': props.type === 'warning',
    'bg-blue-200': props.type === 'info',
    'bg-primary': props.type === 'success'
}))

const closeAlert = () => {
    show.value = false
}

onMounted(() => {
    setTimeout(() => {
        if (parseInt(props.timeout) > parseInt('0')) {
            closeAlert()
        }
    }, parseInt(props.timeout))
})

</script>

<style>

</style>